import './ContactUs.css';
import '../../App.css';
import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import toast, { Toaster } from 'react-hot-toast';
import logo from '../../media/SH-Hydrafacial.png';
function ContactUs() {

    const [recaptchaValue, setRecaptchaValue] = useState(null);
    const recaptcha = useRef()
    let navigate = useNavigate();
    const [formData, setFormData] = useState({
        Name: '',
        Email: '',
        Contact: '',
        Description: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!recaptchaValue) {
            toast.error('Please verify the reCAPTCHA!')
        } else {
        var Url = window.API_PREFIX + 'admin/contact_us'
        fetch(Url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify(formData)
        }).then(resp => resp.json()).then(data => {

            if (data['status'] === "1") {
                toast.success('Admin will contact soon')
                navigate('/')
            }
            else {
                toast.error("Please fill require all fields")
            }
        }
        )
    }
    };

    return (
        <div className='contact-custom-form'>
            <div class="container" style={{maxWidth: "100%"}}>
      <span class="big-circle"></span>
      <img src="img/shape.png" class="square" alt="" />
      <div class="form">
        <div class="contact-info">
          <img src={logo} width={300} alt="logo" />
          <h3 class="title mt-3">Let's get in touch</h3>

          <div class="info mt-4">
            <div class="information">
              <i class="fas fa-map-marker-alt"></i> &nbsp; &nbsp;

              <p className='mb-0'>OPP. BHAVANS SCHOOL, FF/102, PRATAP TOWER, MAKARPURA ROAD, Vadodara,Gujarat, 390004</p>
            </div>
            <div class="information">
              <i class="fas fa-envelope"></i> &nbsp; &nbsp;
              <p className='mb-0'>support@shhydrafacial.in</p>
            </div>
            <div class="information">
              <i class="fas fa-phone"></i>&nbsp;&nbsp;
              <p className='mb-0'>(+91)-7984794957</p>
            </div>
          </div>

          <div class="social-media">
            <p className='mb-0'>Connect with us :</p>
            <div class="social-icons">
              <a href="#">
                <i class="fab fa-facebook-f"></i>
              </a>
              <a href="#">
                <i class="fab fa-twitter"></i>
              </a>
              <a href="#">
                <i class="fab fa-instagram"></i>
              </a>
              <a href="#">
                <i class="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="contact-form">
          <span class="circle one"></span>
          <span class="circle two"></span>

          <form onSubmit={handleSubmit} autocomplete="off">
            <h3 class="title">Contact us</h3>
            <div class="input-container">
              <input type="text"  class="input"  name="Name" value={formData.Name}
                                onChange={handleChange} />
             {!formData?.Name &&( <label for="">Name</label>)}
              <span>Name</span>
            </div>
            <div class="input-container">
              <input type="email"  class="input"   name="Email"  value={formData.Email}
                                onChange={handleChange} />
             {!formData?.Email &&( <label for="">Email</label>)}
              <span>Email</span>
            </div>
            <div class="input-container">
              <input type="tel"  class="input" name="Contact"  value={formData.Contact}
                            onChange={handleChange} />
            {!formData?.Contact &&(  <label for="">Phone</label>)}
              <span>Phone</span>
            </div>
            <div class="input-container textarea">
              <textarea  class="input" name="Description"  value={formData.Description}
                            onChange={handleChange}></textarea>
            {!formData?.Description &&(  <label for="">Message</label>)}
              <span>Message</span>
            </div>
            <ReCAPTCHA
                            className='mt-3'
                            sitekey="6LdCix8rAAAAAEFUnQb-6NRQX3RlXfJO3dQS9qEk"
                            // 6LdCix8rAAAAAG9TeyFCPilCrjJV6E6B-MCsFBsi
                        onChange={(value) => {
                          setRecaptchaValue(value);
                        }}
                        />
            
            <input type="submit" value="Send" class="btn mt-3" />
          </form>
        </div>
      </div>
    </div>




        </div>
    )
}

export default ContactUs;